import { useState } from 'react'

export type UsePaginationProps = {
  initialPage: number
  initialPageSize: number
  totalItems: number
}

export const usePagination = ({ totalItems, initialPageSize, initialPage }: UsePaginationProps) => {
  const [page, setPage] = useState(initialPage)
  const [pageSize, setPageSize] = useState(initialPageSize)

  const totalPages = Math.ceil(totalItems / pageSize)

  const hasPrevious = page > 1

  const hasNext = page < totalPages

  const onChangePageSize = (newPageSize: number) => {
    setPageSize(newPageSize)
  }

  const onChangePage = (newPage: number) => {
    if (newPage < 1) {
      return
    }

    if (totalPages === 0 && newPage === 1) {
      setPage(1)
      return
    }

    if (newPage <= totalPages) {
      setPage(newPage)
    }
  }

  const onNextPage = () => {
    if (hasNext) {
      setPage(prev => prev + 1)
    }
  }

  const onPrevPage = () => {
    if (hasPrevious) {
      setPage(prev => prev - 1)
    }
  }

  return {
    page,
    pageSize,
    totalItems,
    totalPages,
    hasPrevious,
    hasNext,

    onChangePage,
    onChangePageSize,
    onNextPage,
    onPrevPage,
  }
}

export type UsePaginationReturn = ReturnType<typeof usePagination>
